import { Platform } from 'react-native';

type TBoxShadow =
  | {
      offsetX: number;
      offsetY: number;
      blurRadius: number;
      spreadRadius?: number;
      color: string;
      opacity?: number;
      elevation?: number;
    }
  | 'none';

export const getOpacityColor = (color: string, opacity: number) => {
  let colorWithOpacity = color;
  if (!!color.match(/^\#([A-Fa-f0-9]{6})$/)) {
    // Parse alpha (0–1) to 2-digit hex
    const alphaHex = Math.round(opacity * 255)
      .toString(16)
      .padStart(2, '0');
    colorWithOpacity = `${color}${alphaHex}`;
  }

  return colorWithOpacity;
};

export const getBoxShadow = (props: TBoxShadow) => {
  if (props === 'none') {
    return { boxShadow: 'none' };
  } else {
    const { offsetX, offsetY, blurRadius, spreadRadius = 0, color, opacity = 1, elevation = 4 } = props;

    return Platform.select({
      ios: {
        shadowColor: color,
        shadowOpacity: opacity,
        shadowRadius: blurRadius,
        shadowOffset: {
          width: offsetX,
          height: offsetY,
        },
      },
      android: {
        elevation,
      },
      web: {
        boxShadow: `${offsetX}px ${offsetY}px ${blurRadius}px ${spreadRadius}px ${getOpacityColor(color, opacity)}`,
      },
    });
  }
};
